/** Matches backend REMOTE_SUPPORT_INITIATOR_ROLES */
export const REMOTE_SUPPORT_INITIATOR_ROLES = [
  'admin_super_admin',
  'tech_admin',
  'tech_support',
  'tech_support_engineer',
  'tech_lead',
] as const;

export function canInitiateRemoteSupport(role?: string, permissions: string[] = []): boolean {
  if (role && (REMOTE_SUPPORT_INITIATOR_ROLES as readonly string[]).includes(role)) {
    return true;
  }
  if (permissions.includes('*')) return true;
  return permissions.includes('remoteSupportManage') || permissions.includes('remoteSupportView');
}
